import Swiper, { Navigation, Pagination, Scrollbar , EffectCoverflow, Autoplay } from 'swiper';

export const initHomePageSlider = () => {
    new Swiper('.hero-slider .swiper-container', {
        modules: [Navigation, Pagination],
        autoplay: {
            delay: 5000,
        },
        speed: 400,
        loop: true,
        effect: 'fade',
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        paginationClickable: true,
        grabCursor: true,
        navigation: {
            nextEl: '.hero-slider__nav-button--next',
            prevEl: '.hero-slider__nav-button--prev',
        },
    });
};

export const initPackageGallerySlider = () => {
    new Swiper('.package-gallery-swiper', {
        modules: [Navigation, Pagination],
        loop: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });
};

export const initMapMarkerSlider = () => {
    document.querySelectorAll('.map-marker-image-swiper').forEach(function (carousel) {
        if (carousel.swiper) {
            carousel.swiper.destroy(true, true);
        }
        const parentContainer = carousel.closest('.map-info__container');
        new Swiper(carousel, {
            modules: [Navigation, Pagination],
            loop: false,
            slidesPerView: 1,
            navigation: {
                nextEl: parentContainer.querySelector('.map-swiper-image-button-next'),
                prevEl: parentContainer.querySelector('.map-swiper-image-button-prev'),
            },
            noSwiping: true,
            noSwipingClass: 'swiper-no-swiping',
        });
    });

    const markerIds = [
        'Group_20936', 'Group_20937', 'Group_20941', 'Group_20940',
        'Group_20939', 'Group_20938', 'Group_20944', 'Group_20947',
        'Group_20948', 'Group_20946', 'Group_20943', 'Group_20949', 'Group_20950'
    ];

    const closeButtons = document.querySelectorAll('.map-info__close');
    if  (closeButtons){
        closeButtons.forEach(closeButton => {
            closeButton.addEventListener('click', () => {
                const infoWindow = document.getElementById('map-info-window');
                infoWindow.style.display = 'none';
            });
        });
    }

    if (window.innerWidth > 640) {
        interact('#map-info-window').draggable({
            inertia: true,
            modifiers: [
                interact.modifiers.restrictRect({
                    restriction: 'parent',
                    endOnly: true
                })
            ],
            autoScroll: true,
            listeners: {
                move: dragMoveListener,
            }
        });

        function dragMoveListener(event) {
            const target = event.target;
            const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
            const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

            target.style.transform = `translate(${x}px, ${y}px)`;

            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);
        }
    }

    markerIds.forEach(markerId => {
        const markerElement = document.getElementById(markerId);
        if (markerElement) {
            markerElement.addEventListener('click', () => {
                const infoWindow = document.getElementById('map-info-window');
                const ctaWindow = document.getElementById('cta-window');

                if (ctaWindow && ctaWindow.style.display === 'block') {
                    ctaWindow.style.display = 'none';
                }
                infoWindow.style.display = 'block';

                resetMarkerCircles();

                // Change the fill color of the clicked marker
                const circleElement = markerElement.querySelector('circle');
                if (circleElement) {
                    circleElement.setAttribute('fill', '#0a2237');
                }

                const targetMarkerInfo = `js-${markerId.toLowerCase()}`;
                const targetElement = infoWindow.querySelector(`.${targetMarkerInfo}`);


                const allContainers = infoWindow.querySelectorAll('.map-info__container');
                allContainers.forEach(container => {
                    container.style.display = 'none';
                });

                if (targetElement) {
                    targetElement.style.display = 'block';
                }
            });
        }
    });

    function resetMarkerCircles() {
        markerIds.forEach(id => {
            const otherMarker = document.getElementById(id);
            if (otherMarker) {
                const circle = otherMarker.querySelector('circle');
                if (circle) {
                    circle.setAttribute('fill', '#fff');
                }
            }
        });
    }
};




export const initEmployeeSlider = () => {

    const swiper = new Swiper('.swiper', {
        modules: [Navigation],
        // Optional parameters
        //direction: 'vertical',
        loop: true,

        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

    });
};

export const initHeroSlider = () => {


};

export const initGalleryElementCarousel1 = () => {
	document.querySelectorAll('.js-gallery-element-carousel1').forEach(function (carousel) {
		new Swiper(carousel, {
			speed: 400,
			slidesPerView: 1,
			nextButton: carousel.parentNode.querySelector('.js-gallery-element-carousel1-next'),
			prevButton: carousel.parentNode.querySelector('.js-gallery-element-carousel1-prev'),
		});
	});
};

export const initGalleryElementCarousel2 = () => {
	document.querySelectorAll('.js-gallery-element-carousel2').forEach(function (carousel) {
		new Swiper(carousel, {
            modules: [Navigation, Pagination],
			speed: 400,
			spaceBetween: 8,
			slidesPerView: 1.5,
            navigation: {
                nextEl: carousel.parentNode.querySelector('.js-gallery-element-carousel2-next'),
                prevEl: carousel.parentNode.querySelector('.js-gallery-element-carousel2-prev'),
            },
			breakpoints: {
				639: {
					slidesPerView: 2
				},
				1023: {
					slidesPerView: 3
				}
			}
		});
	});
};

export const initColumnSliderElement = () => {
    document.querySelectorAll('.js-column-slider-element').forEach(function (slider) {
        const swiper = new Swiper(slider, {
            modules: [Navigation, Pagination],
            speed: 400,
            spaceBetween: 16,
            slidesPerView: 1.2,
            breakpoints: {
                639: {
                    slidesPerView: 2.2
                },
            }
        });
    });
};



export const initExpandingColumnElementSwiper = () => {
    document.querySelectorAll('.js-expanding-column-element').forEach(function (slider) {
        const swiper = new Swiper(slider, {
            modules: [Navigation, Pagination],
            speed: 400,
            spaceBetween: 16,
            slidesPerView: 1.2,
            nextButton: slider.parentNode.querySelector('.js-gallery-element-carousel2-next'),
            prevButton: slider.parentNode.querySelector('.js-gallery-element-carousel2-prev'),
            breakpoints: {
                639: {
                    slidesPerView: 2.2
                },
                1150: {
                    slidesPerView: 'auto'
                }
            }
        });
    });
};

export const initPackageSlider = () => {
    document.querySelectorAll('.js-package-slider').forEach(function (slider) {
        const swiper = new Swiper(slider, {
            modules: [Navigation, Pagination],
            speed: 400,
            spaceBetween: 16,
            slidesPerView: 1.2,
            nextButton: slider.parentNode.querySelector('.js-gallery-element-carousel2-next'),
            prevButton: slider.parentNode.querySelector('.js-gallery-element-carousel2-prev'),
            breakpoints: {
                639: {
                    slidesPerView: 2.2
                },
                1150: {
                    slidesPerView: 'auto'
                }
            }
        });
    });
};







export const initImageSliderElement = () => {
    document.querySelectorAll('.js-image-slider-element').forEach(function (slider) {
        const parentContainer = slider.closest('.grid-x');
        new Swiper(slider, {
            modules: [Navigation, Pagination, Scrollbar],
            loop: false,
            spaceBetween: 20,
            slidesPerView: 1.15,
            navigation: {
                nextEl: parentContainer.parentNode.querySelector('.content-swiper-button-next'),
                prevEl: parentContainer.parentNode.querySelector('.content-swiper-button-prev'),
            },
            scrollbar: {
                el: parentContainer.parentNode.querySelector('.swiper-scrollbar'),
                hide: false,
            },
        });
    });
};

